/** Injectable timer so the host and relay can be driven synchronously in tests. */
export type SetTimer = (delayMs: number, fire: () => void) => () => void;

export const defaultSetTimer: SetTimer = (delayMs, fire) => {
  const handle = setTimeout(fire, delayMs);
  return () => clearTimeout(handle);
};
